import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { MapContainer as LeafletMapContainer, TileLayer, useMap } from 'react-leaflet';
import { useMapStore } from '../../store/mapStore';
import { useMap as useMapHook } from '../../hooks/useMap';
import './MapContainer.css';
function MapController() {
    const map = useMap();
    const { initializeMap } = useMapHook();
    const isInitializedRef = useRef(false);
    useEffect(() => {
        if (!isInitializedRef.current) {
            initializeMap(map);
            isInitializedRef.current = true;
        }
    }, [map, initializeMap]);
    return null;
}
export default function MapContainer({ children }) {
    const { center, zoom } = useMapStore();
    const [ready, setReady] = useState(false);
    useEffect(() => { setReady(true); }, []);
    if (!ready)
        return _jsx("div", { className: "map-container" });
    return (_jsx("div", { className: "map-container", children: _jsxs(LeafletMapContainer, { center: center, zoom: zoom, scrollWheelZoom: true, style: { height: '100%', width: '100%' }, children: [_jsx(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }), _jsx(MapController, {}), children] }) }));
}
